import { useTranslation } from 'react-i18next'
import {
  StyledFamilyAndFriendsContainer,
  StyledFamilyAndFriendsMiniTitle,
  StyledFamilyAndFriendsSection,
  StyledFamilyAndFriendsCardsSections,
  StyledTabContentTitle,
  StyledSwiperContainer,
} from './styles'
import { FriendsFamilySwiper } from './familyAndFriendsSwiper/FriendsFamilySwiper'
import { Typography } from '@mui/material'
import { useUserRelationships } from 'shared/hooks/useUserRelationships'
import EmptyState from '../../empty-state/EmptyState'
import { Loader } from 'shared/components/loader/loader'

export const FamilyAndFriends = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.familyAndFriends',
  })

  const { friends, family, isLoading, error } = useUserRelationships()

  if (isLoading) return <Loader isLoading={isLoading} />
  if (error) {
    return (
      <Typography color="error">Error loading relationships data.</Typography>
    )
  }
  if (friends.length === 0 && family.length === 0) {
    return <EmptyState />
  }

  return (
    <>
      <StyledFamilyAndFriendsContainer>
        <StyledTabContentTitle>{t('text')}</StyledTabContentTitle>

        <StyledFamilyAndFriendsSection>
          {family.length !== 0 && (
            <StyledFamilyAndFriendsCardsSections>
              <StyledFamilyAndFriendsMiniTitle>
                {t('family')}
              </StyledFamilyAndFriendsMiniTitle>
              <StyledSwiperContainer>
                <FriendsFamilySwiper familyAndFriendsData={family} />
              </StyledSwiperContainer>
            </StyledFamilyAndFriendsCardsSections>
          )}
          {friends.length !== 0 && (
            <StyledFamilyAndFriendsCardsSections>
              <StyledFamilyAndFriendsMiniTitle>
                {t('friends')}
              </StyledFamilyAndFriendsMiniTitle>
              <StyledSwiperContainer>
                <FriendsFamilySwiper familyAndFriendsData={friends} />
              </StyledSwiperContainer>
            </StyledFamilyAndFriendsCardsSections>
          )}
        </StyledFamilyAndFriendsSection>
      </StyledFamilyAndFriendsContainer>
    </>
  )
}
